import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  FaPhone,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaClock,
} from "react-icons/fa";
import "./Contact.css";

function Contact() {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name.trim()) {
      alert(t("contact.requiredName"));
      return;
    }

    if (!form.phone.trim()) {
      alert(t("contact.requiredPhone"));
      return;
    }

    if (!form.message.trim()) {
      alert(t("contact.requiredMessage"));
      return;
    }

    const whatsappNumber = "96103911681";

    const whatsappText = `
${t("contact.formTitle")}

${t("contact.nameLabel")}: ${form.name}
${t("contact.phoneLabel")}: ${form.phone}
${t("contact.emailLabel")}: ${form.email || "-"}
${t("contact.subjectLabel")}: ${form.subject || "-"}

${t("contact.messageLabel")}:
${form.message}
`;

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      whatsappText
    )}`;

    window.open(whatsappUrl, "_blank");

    setSent(true);

    setForm({
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  const openWhatsApp = () => {
    const whatsappNumber = "96103911681";

    const message = t("contact.whatsappMessage");

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <main className={`contact-page ${isArabic ? "rtl" : "ltr"}`}>
      {/* HERO */}
      <section className="contact-hero">
        <div className="contact-hero-bg"></div>

        <div className="contact-container">
          <div className="contact-hero-content">
            <span className="contact-tag">
              {t("contact.tag")}
            </span>

            <h1>
              {t("contact.title")}{" "}
              <span>{t("contact.titleHighlight")}</span>
            </h1>

            <p>{t("contact.description")}</p>
          </div>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section className="contact-info-section">
        <div className="contact-container">
          <div className="contact-info-header">
            <span className="section-tag">
              {t("contact.infoTag")}
            </span>

            <h2>{t("contact.infoTitle")}</h2>

            <p>{t("contact.infoText")}</p>
          </div>

          <div className="contact-info-grid">

            {/* PHONE */}
            <a
              href="tel:+96103911681"
              className="contact-info-card"
            >
              <div className="contact-icon blue">
                <FaPhone />
              </div>

              <div>
                <h3>{t("contact.phoneTitle")}</h3>

                <p>{t("contact.phoneText")}</p>

                <strong>+961 03 911 681</strong>
              </div>
            </a>

            {/* WHATSAPP */}
            <button
              type="button"
              className="contact-info-card whatsapp-card"
              onClick={openWhatsApp}
            >
              <div className="contact-icon green">
                <FaWhatsapp />
              </div>

              <div>
                <h3>{t("contact.whatsappTitle")}</h3>

                <p>{t("contact.whatsappText")}</p>

                <strong>WhatsApp</strong>
              </div>
            </button>

            {/* EMAIL */}
            <a
              href="mailto:medadhub.lb@gmail.com"
              className="contact-info-card"
            >
              <div className="contact-icon yellow">
                <FaEnvelope />
              </div>

              <div>
                <h3>{t("contact.emailTitle")}</h3>

                <p>{t("contact.emailText")}</p>

                <strong>medadhub.lb@gmail.com</strong>
              </div>
            </a>

            {/* LOCATION */}
            <div className="contact-info-card">
              <div className="contact-icon red">
                <FaMapMarkerAlt />
              </div>

              <div>
                <h3>{t("contact.locationTitle")}</h3>

                <p>{t("contact.locationText")}</p>

                <strong>Madad Center</strong>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* FORM */}
      <section className="contact-form-section">
        <div className="contact-container">
          <div className="contact-form-wrapper">

            {/* LEFT SIDE */}
            <div className="contact-form-intro">
              <span className="section-tag">
                {t("contact.formTag")}
              </span>

              <h2>{t("contact.formTitle")}</h2>

              <p>{t("contact.infoText")}</p>

              <div className="working-hours">
                <div className="working-icon">
                  <FaClock />
                </div>

                <div>
                  <h4>{t("contact.workingHoursTitle")}</h4>

                  <p>{t("contact.workingHours")}</p>

                  <span>{t("contact.workingHoursTime")}</span>
                </div>
              </div>

              <button
                type="button"
                className="whatsapp-main-btn"
                onClick={openWhatsApp}
              >
                <FaWhatsapp />
                {t("contact.whatsappButton")}
              </button>
            </div>

            {/* FORM */}
            <form
              className="contact-form"
              onSubmit={handleSubmit}
            >
              {sent && (
                <div className="success-message">
                  <strong>
                    {t("contact.successTitle")}
                  </strong>

                  <span>
                    {t("contact.successText")}
                  </span>
                </div>
              )}

              <div className="form-row">

                <div className="form-group">
                  <label>
                    {t("contact.nameLabel")}
                  </label>

                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder={t(
                      "contact.namePlaceholder"
                    )}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {t("contact.phoneLabel")}
                  </label>

                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder={t(
                      "contact.phonePlaceholder"
                    )}
                  />
                </div>

              </div>

              <div className="form-row">

                <div className="form-group">
                  <label>
                    {t("contact.emailLabel")}
                  </label>

                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder={t(
                      "contact.emailPlaceholder"
                    )}
                  />
                </div>

                <div className="form-group">
                  <label>
                    {t("contact.subjectLabel")}
                  </label>

                  <input
                    type="text"
                    name="subject"
                    value={form.subject}
                    onChange={handleChange}
                    placeholder={t(
                      "contact.subjectPlaceholder"
                    )}
                  />
                </div>

              </div>

              <div className="form-group">
                <label>
                  {t("contact.messageLabel")}
                </label>

                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder={t(
                    "contact.messagePlaceholder"
                  )}
                  rows="6"
                ></textarea>
              </div>

              <button
                type="submit"
                className="send-message-btn"
              >
                <FaPaperPlane />

                <span>
                  {t("contact.submit")}
                </span>
              </button>

            </form>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="contact-cta">
        <div className="contact-container">
          <div className="contact-cta-content">

            <span className="contact-tag">
              {t("contact.ctaTag")}
            </span>

            <h2>{t("contact.ctaTitle")}</h2>

            <p>{t("contact.ctaText")}</p>

            <button
              type="button"
              onClick={openWhatsApp}
              className="cta-contact-btn"
            >
              <FaWhatsapp />

              {t("contact.ctaButton")}
            </button>

          </div>
        </div>
      </section>
    </main>
  );
}

export default Contact;